import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { faCircleCheck, faCircleXmark } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { Button } from '@components/main-components/button/Button';
import { Modal } from '@components/main-components/modals/Modal';
import { ModalContext } from '@context/modal';
import { LEARN_MORE_TIERS } from '@utils/constants';

type Benefit = {
  title: string;
  description: string;
  GA: boolean;
  VIP: boolean;
};

const BENEFITS_INFO = [
  {
    title: 'Collectibility',
    description: 'Collect songs and join the audience',
    GA: true,
    VIP: true,
  },
  {
    title: 'Patronage',
    description: 'Directly support your favourite artists',
    GA: true,
    VIP: true,
  },
  {
    title: 'Scarcity',
    description: 'Only a limited number of editions available',
    GA: false,
    VIP: true,
  },
  {
    title: 'Audio',
    description: 'Audio included in the edition',
    GA: false,
    VIP: true,
  },
  {
    title: 'Golden Egg',
    description: 'Eligible to win an exclusive 1:1 edition',
    GA: false,
    VIP: true,
  },
  {
    title: 'Priority Seating',
    description: 'Special seating and exclusive badging',
    GA: false,
    VIP: true,
  },
] satisfies Benefit[];

export const TiersLearnMoreModal = () => {
  const { closeCancelModal } = ModalContext.useContainer();

  const body = (
    <div className="relative flex w-full flex-col items-center justify-center gap-4 gap-y-6 md:gap-6">
      <table className="w-full text-left">
        <colgroup>
          <col className="w-[78%] md:w-2/12" />
          <col className="w-[16%] md:w-1/12" />
          <col className="w-[16%] md:w-1/12" />
          <col className="md:hidden lg:block lg:w-3/12" />
        </colgroup>
        <thead className="w-full">
          <tr className="border-b border-b-base200 font-base text-base-s uppercase">
            <th scope="col" className="relative isolate py-1 pr-1 text-left  font-medium ">
              Benefits
            </th>
            <th scope="col" className=" table-cell px-1 py-1  text-right  font-medium">
              Forever Edition
            </th>
            <th scope="col" className=" table-cell px-1 py-1  text-right  font-medium">
              Limited Edition
            </th>
          </tr>
        </thead>

        <tbody>
          {BENEFITS_INFO.map((benefit, i) => (
            <tr key={`${benefit.title}-${i}`} className="border-b border-b-base200 ">
              <td className="flex py-3">
                <div className="flex flex-col">
                  <h3 className="font-title text-title-xs font-medium md:text-title-s">
                    {benefit.title}
                  </h3>
                  <p className="font-base text-base-xs text-base500 md:whitespace-nowrap md:text-base-s">
                    {benefit.description}
                  </p>
                </div>
              </td>
              <td
                className={clsx(
                  'px-1 py-3 text-right',
                  benefit.GA ? 'text-fuchsia500' : 'text-base400',
                )}
              >
                <FontAwesomeIcon icon={benefit.GA ? faCircleCheck : faCircleXmark} />
              </td>

              <td
                className={clsx(
                  'px-1 py-3 text-right',
                  benefit.VIP ? 'text-fuchsia500' : 'text-base400',
                )}
              >
                <FontAwesomeIcon icon={benefit.VIP ? faCircleCheck : faCircleXmark} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex w-full items-center gap-3 [&>a]:w-full">
        <Button
          label="Learn More"
          variant="secondary"
          fullWidth
          href={LEARN_MORE_TIERS}
          className="w-full "
        />
        <Button label="Close" variant="primary" onClick={closeCancelModal} fullWidth />
      </div>
    </div>
  );

  return (
    <Modal
      header={
        <div className="flex items-center ">
          <h2 className="font-title text-title-m font-medium md:text-title-l">Compare Editions</h2>
        </div>
      }
      body={body}
      closeModal={closeCancelModal}
      containerStyles={{
        borderRadius: 12,
        '@tablet': {
          width: 420,
        },
      }}
    />
  );
};
